import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { DevBreadcrumbsComponent } from './dev-breadcrumbs';

@NgModule({
  entryComponents: [
    DevBreadcrumbsComponent
  ],
  declarations: [
    DevBreadcrumbsComponent,
  ],
  imports: [
    IonicModule,
  ],
  exports: [
    DevBreadcrumbsComponent
  ]
})
export class DevBreadcrumbsComponentModule { }



// WEBPACK FOOTER //
// ./src/components/dev-breadcrumbs/dev-breadcrumbs.module.ts